import React from 'react';

import {formatDate} from 'utils/datetime';

import Money from 'components/Money';

import './styles.css';

const RentInfoSection = ({
  startDate,
  endDate,
  rentScheduleSummary: {rentPerDay, rentPerWeek, totalValue}
}) => (
  <div className="RentInfoSection">
    <div className="tenancyPeriod">
      <div className="label">Tenancy period</div>
      <div className="value">
        {formatDate(startDate)} - {formatDate(endDate)}
      </div>
    </div>
    <div className="totalValue">
      <div className="label">Total value</div>
      <div className="value">
        <Money amount={totalValue} />
      </div>
    </div>
    <div className="rentPerWeek">
      <div className="label">Rent per week</div>
      <div className="value">
        <Money amount={rentPerWeek} />
      </div>
    </div>
    <div className="rentPerDay">
      <div className="label">Rent per day</div>
      <div className="value">
        <Money amount={rentPerDay} />
      </div>
    </div>
  </div>
);

export default RentInfoSection;
